import {
    DateTimeUtcService,
    DateTimeUtils,
    useAppClockService,
    useDateTimeLocalizationInfo,
    useTimezone,
} from '@mews/framework';

export const useExpirationDaysLeftCount = (expirationDate?: string | null) => {
    const appClockService = useAppClockService();
    const now = appClockService.getAppNowUtc();
    const timezone = useTimezone();
    const localizationInfo = useDateTimeLocalizationInfo();

    if (expirationDate == null) return null;

    const expirationDateString = DateTimeUtils.dateIsoStringToDateString(expirationDate, localizationInfo);
    const expirationDateTimeUtcString = DateTimeUtils.dateStringToDateTimeUtcString(
        expirationDateString,
        localizationInfo,
        timezone
    );
    const expirationDateTimeUtc = DateTimeUtcService.parse(expirationDateTimeUtcString);

    return DateTimeUtcService.diffDays(expirationDateTimeUtc, now);
};
